import * as React from 'react';
import { BaSeStaticAsset } from '../static-asset/static-asset';
import { ImageProps } from './image-props';

export const BaSeImageFlag: React.FC<
  Pick<ImageProps, 'name' | 'description'>
> = ({ name, description }) => (
  <BaSeStaticAsset
    classIdentifier="BaSe--image-flag"
    description={description}
    path={`images/flags/${name}.svg`}
  />
);

BaSeImageFlag.displayName = 'BaSeImageFlag';
